@let corporateDesign = corporateDesignService.corporateDesign();
<aw-ticket-frame
  [suffix]="'ticket-tile'"
  [upperTicketElement]="upper"
  [styling]="styling().frame"
  [attr.data-testid]="id()">
  <ng-template #upper>
    @if (ticket().image) {
      <div
        class="-m-6 mb-6 flex items-center justify-center overflow-hidden rounded-t-2xl">
        <img
          [src]="imagePath() + ticket().image?.image?.id"
          [alt]="ticket().image?.imageAlts ?? [] | language" />
      </div>
    }
    <div
      class="pb-3 text-3xl font-medium"
      [attr.data-testid]="id() | appendTestId: 'title'"
      [attr.aria-label]="ticket().title"
      [ngStyle]="{
        color: corporateDesignService.isDarkModeActive()
          ? corporateDesign.colorAdmixtures.dark_text_high
          : '',
      }">
      {{ (ticket().title | language) || ticket().name }}
    </div>
    @if (ticket().via.length > 0) {
      <div class="pb-3">
        @if (ticket().viaBanner === 'chip') {
          <aw-via-chip
            [ngStyle]="{
              color: corporateDesignService.isDarkModeActive()
                ? corporateDesign.colorAdmixtures.dark_text
                : '',
            }"
            [via]="ticket().via"
            [attr.data-testid]="id() | appendTestId: 'via-chip'">
          </aw-via-chip>
        } @else if (ticket().viaBanner === 'list') {
          <aw-via-list
            [ngStyle]="{
              color: corporateDesignService.isDarkModeActive()
                ? corporateDesign.colorAdmixtures.dark_text
                : '',
            }"
            [via]="ticket().via"
            [attr.data-testid]="id() | appendTestId: 'list'">
            ></aw-via-list
          >
        } @else {
          <aw-via-banner
            [ngStyle]="{
              color: corporateDesignService.isDarkModeActive()
                ? corporateDesign.colorAdmixtures.dark_text
                : '',
            }"
            [attr.data-testid]="id() | appendTestId: 'banner'"
            [bannerOverflow]="styling().frame.borderWidth"
            [via]="ticket().via"></aw-via-banner>
        }
      </div>
    }
    @let ticketPrice = ticket().price;
    @if (ticketPrice !== undefined) {
      <aw-chip
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text
            : '',
          backgroundColor: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_surface_03
            : '',
        }"
        [id]="id() | appendTestId: 'price'"
        [text]="ticketPrice | centsToEuros: '€ ' + ticket().afterPriceText">
      </aw-chip>
    }
    <div
      class="min-w-0 text-base [overflow-wrap:anywhere] [hyphens:auto]"
      [attr.lang]="languageService.activeLanguage().prefix.toLowerCase()"
      [attr.data-testid]="id() | appendTestId: 'description'"
      [attr.aria-label]="descriptionPlainText()"
      [ngStyle]="{
        color: corporateDesignService.isDarkModeActive()
          ? corporateDesign.colorAdmixtures.dark_text_high
          : '',
      }">
      <quill-view
        class="block min-w-0 [&_.ql-editor]:[overflow-wrap:anywhere] [&_.ql-editor]:[hyphens:auto]"
        format="json"
        [content]="descriptionContent()" />
    </div>
  </ng-template>
  <div lower>
    @if (ticket().details.length > 0) {
      <aw-extendable-text
        class="extendable-ticket-text"
        [title]="ticket().detailsTitle | language"
        [id]="id() | appendTestId: 'extendable-test'"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text_high
            : '',
        }">
        <div class="py-3">
          <aw-simple-list
            [id]="id() | appendTestId: 'benefits-list'"
            [items]="ticket().details" />
        </div>
      </aw-extendable-text>
    }
    <div class="pt-4"></div>
    <aw-button
      (click)="onButtonClick.emit(ticket().name)"
      [id]="'order-ticket-button'"
      [style]="'primary'"
      [type]="'button'">
      {{ buttonTextOverride() ?? (buttonText() | language) }}
    </aw-button>
  </div>
</aw-ticket-frame>
